module.exports = __webpack_public_path__ + "static/img/9f.331d9d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/9f.jpg
// module id = /Bnv
// module chunks = 0